import { useNavigate } from 'react-router-dom';
import { Button } from './Button';

export default function ErrorSection({ errorMsg }: { errorMsg?: string }) {
  const navigate = useNavigate();

  return (
    <div className='flex flex-col gap-6 items-center justify-center text-center py-12'>
      <h4 className='text-2xl sm:text-3xl font-semibold'>Sorry about the interruption</h4>

      {errorMsg && <p className='text-base'>{errorMsg}</p>}

      <p className='text-base'>
        There was a technical issue and we’re looking into it.
        <br />
        Please try refreshing the page or come back later.
      </p>

      <Button onClick={() => navigate(0)}>Refresh page</Button>
    </div>
  );
}
